
import { WhatsAppIcon } from './WhatsAppIcon';
import { trackWhatsAppClick } from '@/lib/gtm';

export const FloatingWhatsApp = () => {
  const whatsappUrl = "https://wa.me/5521992698354?text=Ol%C3%A1%2C%20tudo%20bem%3F%20Estava%20no%20site%20e%20preciso%20de%20atendimento.";

  const handleClick = () => {
    trackWhatsAppClick("Fale conosco no WhatsApp", whatsappUrl, "floating-button");
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[999] bg-[#25D366] text-white p-3 md:p-3.5 rounded-full shadow-2xl hover:bg-[#128C7E] transition-all transform hover:-translate-y-1 flex items-center justify-center group"
      aria-label="Falar no WhatsApp"
      onClick={handleClick}
      data-gtm-event="whatsapp_click"
      data-conversion="whatsapp"
      data-button-location="floating-button"
    >
      <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8" />
      <span className="absolute right-full mr-3 bg-white text-gray-800 px-3 py-1.5 rounded-lg text-sm font-bold shadow-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none hidden md:block border border-gray-100">
        Fale conosco no WhatsApp
      </span>
    </a>
  );
};
